import { Box, ButtonBase } from '@mui/material'
import { tokens } from '../theme'

export interface SegmentedTabItem {
  value: string
  label: string
}

interface SegmentedTabsProps {
  items: SegmentedTabItem[]
  value: string
  onChange: (value: string) => void
}

/**
 * Segmentový přepínač „pilulky" (vzor portilio-fe segmentedTabs): šedý track,
 * vybraná položka = bílá pilulka se stínem.
 */
export function SegmentedTabs({ items, value, onChange }: SegmentedTabsProps) {
  return (
    <Box
      role="tablist"
      sx={{
        display: 'inline-flex',
        flexWrap: 'wrap',
        bgcolor: tokens.neutral[100],
        borderRadius: '12px',
        p: '3px',
        gap: '2px',
      }}
    >
      {items.map((item) => {
        const selected = item.value === value
        return (
          <ButtonBase
            key={item.value}
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(item.value)}
            sx={{
              px: '14px',
              py: '7px',
              borderRadius: '9px',
              fontFamily: 'inherit',
              fontSize: '0.8125rem',
              fontWeight: selected ? 600 : 500,
              color: selected ? tokens.neutral[900] : tokens.neutral[500],
              bgcolor: selected ? '#fff' : 'transparent',
              boxShadow: selected
                ? '0 1px 3px rgba(10,30,60,0.12), 0 1px 1px rgba(10,30,60,0.06)'
                : 'none',
              transition: 'all 120ms ease-out',
              '&:hover': selected ? undefined : { color: tokens.neutral[700] },
            }}
          >
            {item.label}
          </ButtonBase>
        )
      })}
    </Box>
  )
}
